<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Add New Feed</ng-container>

    <ng-container *ngIf="form && form.formGroup" dialog-process-in-progress>
        <form [formGroup]="form.formGroup" class="row add-feed-form">
            <div class="col-12">
                <div class="row">
                    <div [ngClass]="{'mb-3': form.controls[0].errors?.length > 0}" class="col-6">
                        <app-panel-input
                            [control]="form.controls[0]"
                            [formControlName]="form.controls[0].name"
                        ></app-panel-input>
                    </div>
                    <div [ngClass]="{'mb-3': form.controls[1].errors?.length > 0}" class="col-6">
                        <app-textarea
                            [control]="form.controls[1]"
                            [formControlName]="form.controls[1].name"
                        ></app-textarea>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div [ngClass]="{'mb-3': form.controls[2].errors?.length > 0}" class="col-6">
                        <app-select
                            [control]="form.controls[2]"
                            [formControlName]="form.controls[2].name"
                        ></app-select>
                    </div>
                    <div [ngClass]="{'mb-3': form.controls[3].errors?.length > 0}" class="col-6">
                        <app-select
                            [control]="form.controls[3]"
                            [formControlName]="form.controls[3].name"
                        ></app-select>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div [ngClass]="{'mb-3': form.controls[4].errors?.length > 0}" class="col-6">
                        <app-amount-input
                            [control]="form.controls[4]"
                            [formControlName]="form.controls[4].name"
                        ></app-amount-input>
                    </div>
                    <div [ngClass]="{'mb-3': form.controls[5].errors?.length > 0}" class="col-6">
                        <app-amount-input
                            [control]="form.controls[5]"
                            [formControlName]="form.controls[5].name"
                        ></app-amount-input>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div [ngClass]="{'mb-3': form.controls[6].errors?.length > 0}" class="col-6">
                        <app-amount-input
                            [control]="form.controls[6]"
                            [formControlName]="form.controls[6].name"
                        ></app-amount-input>
                    </div>
                    <div [ngClass]="{'mb-3': form.controls[7].errors?.length > 0}" class="col-6">
                        <app-amount-input
                            [control]="form.controls[7]"
                            [formControlName]="form.controls[7].name"
                        ></app-amount-input>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div [ngClass]="{'mb-3': form.controls[17].errors?.length > 0}" class="col-6">
                        <app-select
                            [control]="form.controls[17]"
                            [formControlName]="form.controls[17].name"
                        ></app-select>
                    </div>
                    <div [ngClass]="{'mb-3': form.controls[8].errors?.length > 0}" class="col-6">
                        <app-amount-input
                            [control]="form.controls[8]"
                            [formControlName]="form.controls[8].name"
                        ></app-amount-input>
                    </div>
                </div>
            </div>

            <div class="col-12 mb-2">
                <div class="row">
                    <div class="col-6">
                        <app-slide-toggle
                            (change)="hasL1Change($event)"
                            [checked]="form.hasL1"
                            [textOnLeft]="true"
                            [texts]="['Has L1', 'Has L1']"
                        ></app-slide-toggle>
                    </div>
                    <div class="col-6">
                        <app-slide-toggle
                            (change)="hasL2Change($event)"
                            [checked]="form.hasL2"
                            [textOnLeft]="true"
                            [texts]="['Has L2', 'Has L2']"
                        ></app-slide-toggle>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div [ngClass]="{'mb-3': form.controls[9].errors?.length > 0}" class="col-6">
                        <app-panel-input
                            [control]="form.controls[9]"
                            [formControlName]="form.controls[9].name"
                        ></app-panel-input>
                    </div>
                    <div [ngClass]="{'mb-3': form.controls[10].errors?.length > 0}" class="col-6">
                        <app-panel-input
                            [control]="form.controls[10]"
                            [formControlName]="form.controls[10].name"
                        ></app-panel-input>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div [ngClass]="{'mb-3': form.controls[11].errors?.length > 0}" class="col-6">
                        <app-panel-input
                            [control]="form.controls[11]"
                            [formControlName]="form.controls[11].name"
                        ></app-panel-input>
                    </div>
                    <div [ngClass]="{'mb-3': form.controls[12].errors?.length > 0}" class="col-6">
                        <app-panel-input
                            [control]="form.controls[12]"
                            [formControlName]="form.controls[12].name"
                        ></app-panel-input>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <div [ngClass]="{'mb-3': form.controls[13].errors?.length > 0}" class="col-6">
                        <app-panel-input
                            [control]="form.controls[13]"
                            [formControlName]="form.controls[13].name"
                        ></app-panel-input>
                    </div>
                    <div [ngClass]="{'mb-3': form.controls[14].errors?.length > 0}" class="col-6">
                        <app-panel-input
                            [control]="form.controls[14]"
                            [formControlName]="form.controls[14].name"
                        ></app-panel-input>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <!-- Fx suffixes -->
                    <div [ngClass]="{'mb-3': form.controls[18].errors?.length > 0}" class="col-6">
                        <app-panel-input
                            [control]="form.controls[18]"
                            [formControlName]="form.controls[18].name"
                        ></app-panel-input>
                    </div>
                    <!-- Afx suffixes -->
                    <div [ngClass]="{'mb-3': form.controls[19].errors?.length > 0}" class="col-6">
                        <app-panel-input
                            [control]="form.controls[19]"
                            [formControlName]="form.controls[19].name"
                        ></app-panel-input>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <!-- Cfd suffixes -->
                    <div [ngClass]="{'mb-3': form.controls[20].errors?.length > 0}" class="col-6">
                        <app-panel-input
                            [control]="form.controls[20]"
                            [formControlName]="form.controls[20].name"
                        ></app-panel-input>
                    </div>
                    <!-- Options Conflated 5-Sec -->
                    <div [ngClass]="{'mb-3': form.controls[21].errors?.length > 0}" class="col-6">
                        <app-panel-input
                            [control]="form.controls[21]"
                            [formControlName]="form.controls[21].name"
                        ></app-panel-input>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <!-- CBOE One Suffixes -->
                    <div [ngClass]="{'mb-3': form.controls[27].errors?.length > 0}" class="col-6">
                        <app-panel-input
                            [control]="form.controls[27]"
                            [formControlName]="form.controls[27].name"
                        ></app-panel-input>
                    </div>
                    <!-- Tse suffixes -->
                    <div [ngClass]="{'mb-3': form.controls[29].errors?.length > 0}" class="col-6">
                        <app-panel-input [control]="form.controls[29]"
                            [formControlName]="form.controls[29].name"></app-panel-input>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <!-- Xetra Core L1 suffixes -->
                    <div [ngClass]="{'mb-3': form.controls[30].errors?.length > 0}" class="col-6">
                        <app-panel-input [control]="form.controls[30]"
                            [formControlName]="form.controls[30].name"></app-panel-input>
                    </div>
                    <!-- Euronext suffixes -->
                    <div [ngClass]="{'mb-3': form.controls[31].errors?.length > 0}" class="col-6">
                        <app-panel-input [control]="form.controls[31]"
                            [formControlName]="form.controls[31].name"></app-panel-input>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <!-- Xetra Core ETFs and ETPs L1 suffixes -->
                    <div [ngClass]="{'mb-3': form.controls[32].errors?.length > 0}" class="col-6">
                        <app-panel-input [control]="form.controls[32]"
                            [formControlName]="form.controls[32].name"></app-panel-input>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <!-- suffix priority -->
                    <div [ngClass]="{'mb-3': form.controls[15].errors?.length > 0}" class="col-6">
                        <app-select
                            [control]="form.controls[15]"
                            [formControlName]="form.controls[15].name"
                        ></app-select>
                    </div>
                    <!-- Portal selection -->
                    <div [ngClass]="{'mb-3': form.controls[28].errors?.length > 0}" class="col-6">
                        <app-select
                            [control]="form.controls[28]"
                            [formControlName]="form.controls[28].name"
                        ></app-select>
                    </div>
                </div>
            </div>
            <div *ngIf="isNasdaqOrNasdaqUtpSelected" class="col-12 report-map">
                <div class="row">
                    <!-- suffix priority -->
                    <div [ngClass]="{'mb-3': form.controls[22].errors?.length > 0}" class="col-10">
                        <app-select
                            [control]="form.controls[22]"
                            [formControlName]="form.controls[22].name"
                        ></app-select>
                    </div>
                    <div [ngClass]="{'mb-3': form.controls[22].errors?.length > 0}" class="col-2">
                        <a (click)="addReportMap()" class="ml-auto btn btn-primary add-report-map">
                            <span>
                                <i class="fa fa-plus"></i>
                            </span>
                        </a>
                    </div>
                </div>
                <div *ngIf="selectedNasdaqReportMaps.includes(NasdaqReportMapsEnum.ProductCodeForPro)" class="col-12">
                    <div class="row mr-m-26">
                        <!-- Product Code For Pro-->
                        <div [ngClass]="{'mb-3': form.controls[23].errors?.length > 0}" class="col-10">
                            <app-panel-input
                                [control]="form.controls[23]"
                                [formControlName]="form.controls[23].name"
                            ></app-panel-input>
                        </div>
                        <div [ngClass]="{'mb-3': form.controls[22].errors?.length > 0}" class="col-2">
                            <a (click)="removeReportMap(NasdaqReportMapsEnum.ProductCodeForPro)"
                               class="ml-auto btn btn-warning add-report-map">
                            <span>
                                <i class="fa fa-minus"></i>
                            </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedNasdaqReportMaps.includes(NasdaqReportMapsEnum.ProductCodeForNonPro)"
                     class="col-12">
                    <div class="row mr-m-26">
                        <!-- Product Code For Non Pro-->
                        <div [ngClass]="{'mb-3': form.controls[24].errors?.length > 0}" class="col-10">
                            <app-panel-input
                                [control]="form.controls[24]"
                                [formControlName]="form.controls[24].name"
                            ></app-panel-input>
                        </div>
                        <div [ngClass]="{'mb-3': form.controls[22].errors?.length > 0}" class="col-2">
                            <a (click)="removeReportMap(NasdaqReportMapsEnum.ProductCodeForNonPro)"
                               class="ml-auto btn btn-warning add-report-map">
                            <span>
                                <i class="fa fa-minus"></i>
                            </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedNasdaqReportMaps.includes(NasdaqReportMapsEnum.ReportTitleIdForPro)" class="col-12">
                    <div class="row mr-m-26">
                        <!-- Prefix (Billing Location) for the Pro-->
                        <div [ngClass]="{'mb-3': form.controls[25].errors?.length > 0}" class="col-10">
                            <app-panel-input
                                [control]="form.controls[25]"
                                [formControlName]="form.controls[25].name"
                            ></app-panel-input>
                        </div>
                        <div [ngClass]="{'mb-3': form.controls[22].errors?.length > 0}" class="col-2">
                            <a (click)="removeReportMap(NasdaqReportMapsEnum.ReportTitleIdForPro)"
                               class="ml-auto btn btn-warning add-report-map">
                            <span>
                                <i class="fa fa-minus"></i>
                            </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedNasdaqReportMaps.includes(NasdaqReportMapsEnum.ReportTitleIdForNonPro)"
                     class="col-12">
                    <div class="row mr-m-26">
                        <!-- Prefix (Billing Location) for the Non Pro-->
                        <div [ngClass]="{'mb-3': form.controls[26].errors?.length > 0}" class="col-10">
                            <app-panel-input
                                [control]="form.controls[26]"
                                [formControlName]="form.controls[26].name"
                            ></app-panel-input>
                        </div>
                        <div [ngClass]="{'mb-3': form.controls[22].errors?.length > 0}" class="col-2">
                            <a (click)="removeReportMap(NasdaqReportMapsEnum.ReportTitleIdForNonPro)"
                               class="ml-auto btn btn-warning add-report-map">
                            <span>
                                <i class="fa fa-minus"></i>
                            </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </ng-container>
</app-dialog>
